<div class="tw-relative" *ngIf="show && hasAnyOrigins" id="origins-preview-dropdown">
  <button
    class="tw-rounded-full tw-border tw-bg-white tw-flex tw-justify-center tw-items-center tw-px-5 tw-py-3 tw-gap-2 focus:tw-outline-0 tw-transition-colors tw-h-10"
    [ngClass]="isBlocked
      ? 'tw-border-gray-300 tw-text-gray-400 tw-cursor-not-allowed'
      : 'tw-border-[#0F93CC] tw-text-[#0F93CC] hover:tw-bg-blue-50'"
    type="button"
    (click)="toggleDropdown()"
    [class.!tw-bg-blue-50]="isOpen"
    [attr.aria-disabled]="isBlocked"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    [mhTooltip]="tooltipKey | translate"
    width="tw-w-fit"
    position="above"
  >
    <i class="far fa-link" [ngClass]="isBlocked ? 'tw-text-gray-400' : 'tw-text-[#0F93CC]'"></i>
  </button>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen && !isBlocked"
    [cdkConnectedOverlayHasBackdrop]="true"
    cdkConnectedOverlayBackdropClass="tw-transparent"
    (backdropClick)="closeDropdown()"
    (detach)="closeDropdown()"
  >
    <div class="tw-rounded-lg tw-shadow-xl tw-p-1 tw-bg-white tw-mt-1 tw-min-w-[200px]">
      <div class="tw-flex tw-flex-col tw-gap-1">
        <button 
          *ngFor="let item of activeOriginsUrls; let last = last; trackBy: trackByUrl"
          type="button"
          (click)="handleOpenPreview(item.url, item.name)"
          class="tw-px-3 tw-py-2 tw-text-sm tw-text-gray-700 hover:tw-bg-gray-100 tw-rounded tw-transition-colors tw-block tw-no-underline hover:tw-no-underline tw-text-left"
          [class.tw-border-b]="!last"
          [class.tw-border-gray-200]="!last"
        >
          {{ item.name }}
        </button>
      </div>
    </div>
  </ng-template>
</div>
